import { Deserializable } from '../../protocols/deserializable';
import { VariantBadge } from '../../product/dto/variant-badge';

export class BadgeMapping implements Deserializable {
  entityId: number;
  categoryKey: string;
  restrictedValues: string[];
  mappings: Map<string, string>;
  dateCreated: number;
  lastModified: number;
  hydratedCustomMappings: Map<string, VariantBadge | null>;
  hydratedCuratedMappings: Map<string, VariantBadge | null>;

  onDeserialize() {
    this.deserializeMappings();
    this.deserializeHydratedCustomMappings();
    this.deserializeHydratedCuratedMappings();
    this.restrictedValues = Array.from(this.restrictedValues || []);
  }

  private deserializeMappings(): void {
    this.mappings = window?.injector?.Deserialize?.genericMap(this.mappings) ?? new Map<string, string>();
  }

  private deserializeHydratedCustomMappings() {
    this.hydratedCustomMappings =
      window?.injector?.Deserialize?.mapOf(VariantBadge, this.hydratedCustomMappings) ??
      new Map<string, VariantBadge | null>();
  }

  private deserializeHydratedCuratedMappings() {
    this.hydratedCuratedMappings =
      window?.injector?.Deserialize?.mapOf(VariantBadge, this.hydratedCuratedMappings) ??
      new Map<string, VariantBadge | null>();
  }
}
